import React from 'react';
/**
 * `UserNotFoundPage` is a minimal error page that displays an error message
 * supplied via router location state.
 */

import { useLocation } from 'react-router-dom';

type LocationState = {
  error: string;
};

const UserNotFoundPage = (): JSX.Element => {
  const { state } = useLocation();
  const { error } = state as LocationState;

  return (
    <div>
      <h3>{error}</h3>
    </div>
  );
};

export default UserNotFoundPage;
